"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var breakpoints = ['sm', 'md', 'lg', 'xl'];

var getIframeHeightProps = function getIframeHeightProps() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    sm: 'bodyOffset'
  };
  var autoHeight = {
    height: 'auto',
    heightCalculationMethod: 'bodyOffset',
    sizeHeight: true
  };
  return breakpoints.reduce(function (iframeHeightProps, currBP, currIndex) {
    if (!height[currBP] && currBP === 'sm') {
      return iframeHeightProps;
    }

    if (!height[currBP]) {
      var prevKey = Object.keys(iframeHeightProps)[currIndex - 1];
      iframeHeightProps[currBP] = iframeHeightProps[prevKey];
      return iframeHeightProps;
    }

    var isAutoResizeHeight = height[currBP] === 'lowestElement' || height[currBP] === 'bodyOffset';
    iframeHeightProps[currBP] = {
      height: isAutoResizeHeight ? 'auto' : height[currBP],
      heightCalculationMethod: height[currBP] === 'lowestElement' ? 'lowestElement' : 'bodyOffset',
      sizeHeight: isAutoResizeHeight
    };
    return iframeHeightProps;
  }, {
    sm: autoHeight
  });
};

var _default = getIframeHeightProps;
exports["default"] = _default;
//# sourceMappingURL=getIframeHeightProps.js.map